declare const $;

export function tagContent() {
  var hash = window.location.hash;
  if (hash.length > 0) {
    var target = $(hash);
    target = target.length ? target : $("[name=" + hash.slice(1) + "]");
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      //event.preventDefault();
      $(window).animate(
        {
          scrollTop: target.offset().top - 150
        },
        1000,
        function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            // Checking if the target was focused
            return false;
          } else {
            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          }
        }
      );
    }
  }
}
